import { trigger, style, animate, transition } from '@angular/animations';
import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LightboxData } from '@app/add-product/models/lightbox.model';

@Component({
    selector: 'sp-lightbox-zoom',
    templateUrl: './lightbox-zoom.component.html',
    styleUrls: ['./lightbox-zoom.component.scss'],
    animations: [
        trigger('zoomAnimation', [
            transition('void => *', [
                style({ transform: 'scale(0)' }),
                animate('300ms ease-out', style({ transform: 'scale(1)' })),
            ]),
            transition('* => void', [
                style({ transform: 'scale(1)' }),
                animate('300ms ease-in', style({ transform: 'scale(0)' })),
            ]),
        ]),
        trigger('slideInOut', [
            transition(':increment', [
                style({ transform: 'translateX(100%)' }),
                animate('300ms', style({ transform: 'translateX(0)' })),
            ]),
            transition(':decrement', [
                style({ transform: 'translateX(-100%)' }),
                animate('300ms', style({ transform: 'translateX(0)' })),
            ]),
        ]),
    ],
})
export class LightboxZoomComponent implements OnInit {
    currentIndex: number;
    zoomLevel: number = 100; // Initial zoom level
    maxZoomLevel: number = 200;
    minZoomLevel: number = 100;
    zoomScale: number = 10;
    isSizeChart: boolean;
    @ViewChild('lightbox_preview_display_container') zoomContainer: ElementRef;
    constructor(
        public dialogRef: MatDialogRef<LightboxZoomComponent>,
        @Inject(MAT_DIALOG_DATA) public data: LightboxData
    ) {
        this.currentIndex = data.initialIndex;
        this.isSizeChart = data.isSizeChart;
    }

    ngOnInit(): void {}

    zoomIn(): void {
        this.zoomLevel =
            this.zoomLevel >= this.maxZoomLevel
                ? this.maxZoomLevel
                : this.zoomLevel + this.zoomScale;
    }

    zoomOut(): void {
        this.zoomLevel =
            this.zoomLevel <= this.minZoomLevel
                ? this.minZoomLevel
                : this.zoomLevel - this.zoomScale;
    }

    closeLightbox(): void {
        this.dialogRef.close();
    }

    nextMedia(): void {
        this.currentIndex = (this.currentIndex + 1) % this.data.gallery.length;
        this.zoomLevel = this.minZoomLevel;
    }

    prevMedia(): void {
        this.currentIndex =
            (this.currentIndex - 1 + this.data.gallery.length) %
            this.data.gallery.length;
        this.zoomLevel = this.minZoomLevel;
    }

    zoomInZoomOut(event: WheelEvent): void {
        const zoomContainerElement = this.zoomContainer.nativeElement;
        const boundingBox = zoomContainerElement.getBoundingClientRect();

        const mouseX = event.clientX - boundingBox.left;
        const mouseY = event.clientY - boundingBox.top;

        // Adjust the zoom level based on the wheel delta
        const delta = Math.sign(event.deltaY);
        this.zoomLevel += delta * this.zoomScale * -1; // Adjust the zoom factor based on your preference

        // Ensure the zoom level stays within a reasonable range
        this.zoomLevel = Math.max(
            this.minZoomLevel,
            Math.min(this.zoomLevel, this.maxZoomLevel)
        );

        const newScrollLeft =
            (mouseX / zoomContainerElement.clientHeight) *
            (zoomContainerElement.scrollWidth -
                zoomContainerElement.clientWidth);
        const newScrollTop =
            (mouseY / zoomContainerElement.clientHeight) *
            (zoomContainerElement.scrollHeight -
                zoomContainerElement.clientHeight);
        zoomContainerElement.scrollLeft = newScrollLeft;
        zoomContainerElement.scrollTop = newScrollTop;

        // Prevent the default scroll behavior
        event.preventDefault();
    }
}
